export const iPhoneLink: string = 'https://apps.apple.com/us/app/epic-haiku-limerick/id348308661';

export const iPadLink: string = 'https://apps.apple.com/us/app/epic-canto/id395395172';

export const androidLink: string = 'https://play.google.com/store/apps/details?id=com.epic.haiku.android&hl=en_US&gl=US';

export const iPhoneHaikuSetup: string = 'epichaiku://handheld/config/XyXYd2W%2bN7LVkunjVIhKHfjtfuY5fi0SaHTVpVtAzhh779PGN24DjpKg%2besXPUL4';

export const iPadCantoSetup: string = 'epiccanto://handheld/config/XyXYd2W%2bN7LVkunjVIhKHfjtfuY5fi0SaHTVpVtAzhh779PGN24DjpKg%2besXPUL4';

export const androidHaikuSetup: string = 'epichaiku://handheld/config/XyXYd2W%2bN7LVkunjVIhKHfjtfuY5fi0SaHTVpVtAzhh779PGN24DjpKg%2besXPUL4';

export const twoFactorGuide: string = 'Haiku2FAguide.pdf';

export const desktop: string = 'Desktop';

export const tablet: string = 'Tablet';

export const phone: string = 'Phone';
